import { CreditPolicyResponseModel } from './../models/response/credit-policy-response';
import { Paging } from './../models/page';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Personality } from '../@core/constants';
import { CreditPolicyRequestModel } from '../models/request/credit-policy-request';
import { ConfigurationService } from './configuration.service';
import { ResponseModel } from '../models/response-model';

@Injectable({
  providedIn: 'root',
})
export class CreditPolicyService {
  private url = `${environment.url}/creditPolicy`;

  constructor(private http: HttpClient) {}

  getCreditPolicy(
    creditPolicyRequest: CreditPolicyRequestModel
  ): Observable<ResponseModel<Paging<Array<CreditPolicyResponseModel>>>> {
    let ageParam = '';

    const params = this.setParams(creditPolicyRequest, ageParam);

    return this.http.get<
      ResponseModel<Paging<Array<CreditPolicyResponseModel>>>
    >(this.url, { params });
  }

  private setParams(
    creditPolicyRequest: CreditPolicyRequestModel,
    ageParam: string
  ): HttpParams {
    let params = new HttpParams();

    const {
      personality,
      creditProcedure,
      age,
      salesOrg,
      creditGroup,
      infoCategory,
      riskLevel,
      productClass,
      loansClass,
      product,
    } = creditPolicyRequest;

    if (personality != undefined) {
      params = params.append(
        'customerType',
        personality == Personality.LEGAL_ENTITY ? '2' : '1'
      );
    }

    if (creditProcedure != undefined) {
      params = params.append('creditProcedure', creditProcedure);

      if (creditProcedure.match('JURIDI') == null) {
        if (age != undefined) {
          params = params.append('age', age);
        }
      }
    }

    if (salesOrg != undefined) {
      params = params.append('salesOrg', salesOrg);
    }

    if (creditGroup != undefined) {
      params = params.append('creditGroup', creditGroup);
    }

    if (infoCategory != undefined) {
      params = params.append('infoCategory', infoCategory);
    }

    if (riskLevel != undefined) {
      params = params.append('riskLevel', riskLevel);
    }

    if (productClass != undefined) {
      params = params.append('productClass', productClass);
    }

    if (loansClass != undefined) {
      params = params.append('loansClass', loansClass);
    }

    if (product != undefined) {
      params = params.append('product', product);
    }

    return params;
  }
}
